import {ReactNode} from 'react';
import ChekinProSettings from 'ChekinProSettings';
import {Route} from 'react-router-dom';
import {PATHS, verificationTypesRoutes} from './constants';
import {IVQRGuard, IVDocumentTypeGuard, IVVerifiedContactsGuard} from 'components/guards';
import IdentityVerification from 'pages/IdentityVerification';
import {
  BackScanView,
  DocumentSelectionView,
  FrontScanView,
  SelfieScanView,
  StartView,
  UploadingTypeView,
  ScanQRCodeView,
  IVQRScanView,
  IVQRScannerView,
  SelfieLivenessView,
  SelfieInstructionsView,
  ContactsVerificationView,
} from 'pages/IdentityVerification/views';
import {KioskoScanDocumentView} from 'pages/KioskoScanDocumentView';

type IVRoutesProps = {
  isLivenessDetectionEnabled?: boolean;
  children?: ReactNode;
};

function getIVRoutes({isLivenessDetectionEnabled, children}: IVRoutesProps) {
  return verificationTypesRoutes.map((route, index) => (
    <Route key={index} path={route} element={<IdentityVerification />}>
      {!ChekinProSettings.isSDK ? (
        <Route path={PATHS.verification.scanQRCode} element={<ScanQRCodeView />} />
      ) : null}
      <Route path={PATHS.verification.qrScan} element={<IVQRScanView />} />
      <Route path={PATHS.verification.qrScanner} element={<IVQRScannerView />} />

      <Route
        index
        element={
          <IVQRGuard>
            <StartView />
          </IVQRGuard>
        }
      />
      <Route
        path={PATHS.verification.contacts}
        element={
          <IVQRGuard>
            <ContactsVerificationView />
          </IVQRGuard>
        }
      />
      <Route
        path={PATHS.verification.documentSelection}
        element={
          <IVQRGuard>
            <IVVerifiedContactsGuard>
              <DocumentSelectionView />
            </IVVerifiedContactsGuard>
          </IVQRGuard>
        }
      />
      <Route
        path={`${PATHS.verification.uploadingType}/:type`}
        element={
          <IVQRGuard>
            <IVDocumentTypeGuard>
              <UploadingTypeView />
            </IVDocumentTypeGuard>
          </IVQRGuard>
        }
      />
      <Route
        path={`${PATHS.verification.front}/:uploadType`}
        element={
          <IVQRGuard>
            <IVDocumentTypeGuard>
              <FrontScanView />
            </IVDocumentTypeGuard>
          </IVQRGuard>
        }
      />
      <Route
        path={`${PATHS.verification.back}/:uploadType`}
        element={
          <IVQRGuard>
            <IVDocumentTypeGuard>
              <BackScanView />
            </IVDocumentTypeGuard>
          </IVQRGuard>
        }
      />
      <Route
        path={PATHS.verification.selfieInstructions}
        element={
          <IVQRGuard>
            <IVDocumentTypeGuard>
              <SelfieInstructionsView />
            </IVDocumentTypeGuard>
          </IVQRGuard>
        }
      />
      <Route
        path={PATHS.verification.selfie}
        element={
          <IVQRGuard>
            <IVDocumentTypeGuard>
              {isLivenessDetectionEnabled ? <SelfieLivenessView /> : <SelfieScanView />}
            </IVDocumentTypeGuard>
          </IVQRGuard>
        }
      />
      <Route
        path={PATHS.verification.kioskoScanDocument}
        element={
          <IVQRGuard>
            <KioskoScanDocumentView />
          </IVQRGuard>
        }
      />
      {children}
    </Route>
  ));
}

export {getIVRoutes};
